<template>
  <v-navigation-drawer
    v-if="$vuetify.breakpoint.smAndDown"
    dark
    absolute
    temporary
    v-model="navDrawer"
  >
    <v-container>
      <v-list nav>
        <v-list-item>
          <v-list-item-content>
            <h3 class="text-uppercase">Vira Designs</h3>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="$router.push(`${item.route}`)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      items: [
        { title: "About", route: "/about" },
        { title: "Works", route: "/work" },
        { title: "Contact", route: "/contact" }
      ]
    };
  },
  computed: {
    ...mapState(["navDrawer"])
  }
};
</script>

<style></style>
